const React = require('react');
require('./search-head.scss');
const shallowCompare = require('react-addons-shallow-compare');

const SearchHead = React.createClass({
  displayName: 'SearchHead',
  propTypes:{
    placeholder:React.PropTypes.string,
    buttonKind:React.PropTypes.object.isRequired,
    getKeyWord:React.PropTypes.func.isRequired,
    handleBlur:React.PropTypes.func,
  },
  getDefaultProps() {
    return { placeholder:'' };
  },
  getInitialState() {
    return {
      keyWord:'',
      showClearIcon:false,
    };
  },

  componentDidMount() {
    this.refs.keyword.focus();
  },

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },

  changeKeyWord() {
    const { getKeyWord } = this.props;
    const showClearIcon = !!this.refs.keyword.value;

    setTimeout(() => {
      this.setState({ showClearIcon });
    }, 300);
    getKeyWord(this.refs.keyword.value);
  },

  handleBlur() {
    const { handleBlur } = this.props;
    if (handleBlur) {
      handleBlur();
    }
  },

  clearInput(e) {
    e.preventDefault();
    const { getKeyWord } = this.props;
    this.setState({ showClearIcon:false }, () => {
      this.refs.keyword.value = '';
      getKeyWord('');
    });
  },

  render() {
    const { placeholder, buttonKind } = this.props;
    const { showClearIcon } = this.state;
    return (
      <div className="search-head of">
        <span className="search-button fr" onTouchTap={(e) => buttonKind.clickCallBack(e)}>{buttonKind.text}</span>
        <div className="search-input-outer of">
          <input
            type="text"
            placeholder={placeholder}
            className="search-input"
            maxLength="20"
            ref="keyword"
            onChange={this.changeKeyWord}
            onBlur={this.handleBlur}
          />
          {
            showClearIcon &&
              <i className="clearIcon" onTouchTap={this.clearInput}></i>
          }
        </div>
      </div>
    );
  },
});

module.exports = SearchHead;



// WEBPACK FOOTER //
// ./src/component/mui/search-head.jsx